/* import __COLOCATED_TEMPLATE__ from './custom-assets-domain.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isBlank, isPresent } from '@ember/utils';
import ajax from 'embercom/lib/ajax';

export default class CustomAssetsDomain extends Component {
  @service intl;
  @service notificationsService;
  @service store;
  @service appService;

  @tracked assetsDomain;
  @tracked model;
  @tracked showModal = false;

  constructor() {
    super(...arguments);
    this.assetsDomain = this.args.customAssetsDomain?.assetsDomain;
    this.model = this.args.customAssetsDomain;
  }

  get isSaveButtonDisabled() {
    if (isBlank(this.assetsDomain)) {
      return true;
    }

    return this.model?.assetsDomain === this.assetsDomain;
  }

  get isRemoveButtonDisabled() {
    return isBlank(this.model?.assetsDomain);
  }

  get validRecordExists() {
    return this.model?.validRecordExists;
  }

  @action
  async save() {
    try {
      if (isPresent(this.assetsDomain)) {
        let model =
          this.args.customAssetsDomain ||
          this.store.createRecord('settings/custom-email-assets-domain');
        model.assetsDomain = this.assetsDomain;
        await model.save();
        this.model = model;
        this.notificationsService.notifyConfirmation(
          this.intl.t('settings.email.custom-assets-domain.save-success'),
        );
      }
    } catch (error) {
      this.notificationsService.notifyResponseError(error);
    }
  }

  @action
  async remove() {
    try {
      await this.args.customAssetsDomain.destroyRecord();
      this.model = null;
      this.notificationsService.notifyConfirmation(
        this.intl.t('settings.email.custom-assets-domain.remove-success'),
      );
      this.showModal = false;
    } catch (error) {
      this.notificationsService.notifyResponseError(error);
    }
  }

  @action
  async checkStatus() {
    try {
      await ajax({
        url: `/ember/settings/custom_email_assets_domains/${this.model.id}/verify`,
        type: 'PUT',
        data: JSON.stringify({
          app_id: this.appService.app.id,
        }),
      });
      this.model.validRecordExists = true;
      this.notificationsService.notifyConfirmation(
        this.intl.t('settings.email.custom-assets-domain.check-success'),
      );
    } catch (error) {
      this.notificationsService.notifyResponseError(error);
    }
  }
}
